import { render } from "./FooterData.vue?vue&type=template&id=78159115&scoped=true"
import script from "./FooterData.vue?vue&type=script&lang=js"
export * from "./FooterData.vue?vue&type=script&lang=js"

import "./FooterData.vue?vue&type=style&index=0&id=78159115&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78159115"]])

export default __exports__